import { cn } from "@/lib/utils";

interface PageHeaderProps {
  /** Page title */
  title: string;
  /** Optional subtitle / description */
  description?: string;
  /** Breadcrumb or back link */
  breadcrumb?: React.ReactNode;
  /** Action buttons (right side) */
  actions?: React.ReactNode;
  className?: string;
}

function PageHeader({
  title,
  description,
  breadcrumb,
  actions,
  className,
}: PageHeaderProps) {
  return (
    <div className={cn("space-y-[var(--space-2)]", className)}>
      {breadcrumb && <div className="mb-[var(--space-1)]">{breadcrumb}</div>}
      <div className="flex items-start justify-between gap-[var(--space-4)]">
        <div className="min-w-0">
          <h1
            title={title}
            className="font-heading text-[length:var(--font-size-2xl)] sm:text-[length:var(--font-size-3xl)] font-[number:var(--font-weight-bold)] tracking-[var(--letter-spacing-tight)] text-[var(--color-text-primary)] truncate"
          >
            {title}
          </h1>
          {description && (
            <p className="mt-[var(--space-2)] text-[length:var(--font-size-base)] text-[var(--color-text-muted)]">
              {description}
            </p>
          )}
        </div>
        {actions && (
          <div className="flex shrink-0 items-center gap-[var(--space-2)]">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}

export { PageHeader };
export type { PageHeaderProps };
